import React from 'react'

import Loading from './Loading'

const LoadingWrapper = ({ loading, children, ...props }) => {
  if (loading) return <Loading {...props} />
  return children
}

export default LoadingWrapper
